import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		catchArr: [
			'Login',
			'ForgetPas',
			'Register',
			'ReSuccessful',
			'ShowRes',
			'amazonCallBack',
			'loadPage',
			'loanHtml',
			'loginrealName',
			'merchSubmit',
			'addedServices',
			'serviceAddList',
			'companyRegisterDetail',
			'companyRegister',
			'VATRegister',
			'shopGuide',
			'independencyStation'
		]
	},
	mutations: {
		// 对指定组件进行动态更改缓存（缓存）--组件调用该方法时，判断该组件是否存在于该缓存数组，无则添加
		iskeepAlive(state, component) {
			let index = state.catchArr.indexOf(component);
			index == -1 && state.catchArr.push(component);
		},
		// 对指定组件进行动态更改缓存（不缓存）--组件调用该方法时，从缓存数组中删除对应的组件元素
		noKeepAlive(state, component) {
			let index = state.catchList.indexOf(component);
			index > -1 && state.catchList.splice(index, 1);
		}
	}
})
